import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../IndividualPlan/tokens';

export const TableWrapper = styled(Box)({
  width: '100%',
  border: `1px solid ${COLORS.divider}`,
  borderRadius: 16,
  overflow: 'hidden',
  backgroundColor: '#FFFFFF',
});
